// removed by extract-text-webpack-plugin
module.exports = {"totpQrcode":"Totp__totpQrcode___3OH-m"};


//////////////////
// WEBPACK FOOTER
// ./src/Totp.css
// module id = 12
// module chunks = 0 1